import { render, staticRenderFns } from "./CustomerTradeInHistoryTab.vue?vue&type=template&id=0f889174&scoped=true"
import script from "./CustomerTradeInHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerTradeInHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerTradeInHistoryTab.vue?vue&type=style&index=0&id=0f889174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f889174",
  null
  
)

export default component.exports